import React from 'react';
import {Link, useRouteMatch} from "react-router-dom";
import * as SpotInfo from "./SpotInfo";

const current = "/~Solferino/broadcasts/spot-info/log";

export function BuildPage(): Page {
  return {title: "旧発言テーブルログ", path: current, parent: SpotInfo.BuildPage()};
}

const log: [string, React.ReactNode][] = [
  ["2010/05/21 06:12:25", "やっぱり未読回収が終わらないんですね"],
  ["2010/05/20 20:11:26", "アップロード作業が完了したら開始です"],
  ["2010/05/17 22:37:21", "今日は三人くらい攻略する勢いで行きたい"],
  ["2010/05/15 21:10:50", "実況開始。今日も二人は攻略します"],
  ["2010/05/11 21:14:06", "今日も眠いけど二三人攻略しまう"],
  ["2010/05/11 20:40:32", "風呂上がったら実況開始"],
  ["2010/05/09 01:09:51", "再起動完了したかもです"],
  ["2010/05/09 01:05:31", "再起動中です"],
  ["2010/05/07 20:46:36", "今日はちゃんと実況やるよ"],
  ["2010/05/03 21:13:36", "このタイプの実況は久々だからアクシデント頻発の可能性有り。とりあえず音量調整からかな。"],
  ["2010/05/03 20:59:27", "そろそろ始めるか"],
  ["2010/05/02 18:20:29", "明日夕方より配信。撲からは以上。"],
  ["2010/04/30 02:48:35", <>グランドフィナーレ！<br/>最後までノクターン実況を応援して下さった皆様、どうもありがとうございます！</>],
  ["2010/04/28 22:34:07", "明日の夕方あたり実況するんじゃないだろうか"],
  ["2010/04/24 04:42:31", "このまんまだと永久に終わりそうもないから、次回までに対策を考えたいと思います。"],
  ["2010/04/23 20:09:26", "実況しますの"],
  ["2010/03/13 22:20:05", <>現在サードアイ探し。<br/>※60グループほど倒せば一つ手に入ると思います。<br/>残3</>],
  ["2010/03/10 20:50:27", "もうすぐ実況します"],
  ["2010/03/09 06:38:50", "今回は全然進まんかったね"],
  ["2010/03/08 21:43:34", "まもなく再開しま"],
  ["2010/03/08 20:14:28", "申し訳ない！　かなりかかりそうです。長くて二時間です。判断は皆さんにお任せします。"],
  ["2010/03/08 19:58:24", ">>558 どーもー　今日もやっていきますよー"],
  ["2010/03/08 19:40:29", "実況予告入れるの忘れてたけど、やります！"],
  ["2010/03/04 06:14:57", "次回はカオスさんまで行っちゃおう！（予定）"],
  ["2010/03/03 21:44:18", "あ、文字化けだ。バグ発見 追記：修正済"],
  ["2010/03/03 21:43:49", "じゃあ、今日も魔術っぽいの縛っていきますねー >>765 こんばんはー"],
  ["2010/03/03 20:54:24", "今日やるわ。ちょっと後で。"],
  ["2010/03/02 03:04:50", "プロバイダのメンテを忘れていた情けないわしがいた！　すまん。"],
  ["2010/03/01 23:28:43", "今回は魔術っぽいもの全部縛りです"],
  ["2010/03/01 22:46:42", "本日の実況は予定通り行われますが、2chが韓国からの攻撃により鯖落ち状態の為、避難所か臨時掲示板でご覧下さい。なお、鯖が復帰し次第フリーダム本スレに復帰をお願いいたします。"],
  ["2010/02/23 06:37:05", "おしまいっ！"],
  ["2010/02/23 02:08:18", "2週目は魔法縛るよ"],
  ["2010/02/23 01:49:21", "再開しまう"],
  ["2010/02/23 01:43:16", "一旦休憩入ります"],
  ["2010/02/22 22:57:41", "あらすじ：カオスせーんはゆかいだなー"],
  ["2010/02/22 22:56:55", <>iTunesのフルボリュームは小さいよね。<br/>開始しました。</>],
  ["2010/02/22 22:24:03", "30分後開始"],
  ["2010/02/22 19:44:18", "まだ始まらないよ"],
  ["2010/02/14 11:29:04", "掲示板移転完了！"],
  ["2010/02/13 23:49:42", "まもなく掲示板移転"],
  ["2010/02/13 06:52:07", <>アレは準備段階だった、ということは。<br/>次回はカオスさんとたっぷり戦えそうです。</>],
  ["2010/02/13 00:26:53", "スーパーレベル上げタイム"],
  ["2010/02/12 21:00:32", "あらすじのようなもの：あいつを殴りに行こうぜ！"],
  ["2010/02/12 20:43:49", "21:00 開始予定……"],
  ["2010/02/12 19:44:18", "思いついたことがあるので、ちょっと遅くなるかもしれません。"],
  ["2010/02/09 03:16:15", "だいたい大丈夫そうね。終了しまう"],
  ["2010/02/09 00:49:53", "万一見てる人がいたら見えてるか掲示板に書いてくれると助かりまう"],
  ["2010/02/09 00:48:03", "こっそりテストしまう"],
  ["2010/02/02 22:28:30", "ちゃんと動いてるみたいね"],
];

export function Render(props: SolferinoProps) {
  const [rendered, setRendered] = React.useState(false);

  const isExact = useRouteMatch(current)?.isExact;
  React.useEffect(() => {
    if (isExact && !rendered) {
      setRendered(true);
      props.setPage(BuildPage());
    }
  }, [isExact, rendered, props]);

  return (
    <div className="SpotInfo-Log">
      <dl>
        {log.map(([date, text]) => (
          <React.Fragment key={date}>
            <dt>{date}</dt>
            <dd>{text}</dd>
          </React.Fragment>
        ))}
      </dl>
      <p><Link to={"/~Solferino/broadcasts/spot-info"}>戻る</Link></p>
      <address>AntennaJane　2010-05-26 作成　随時更新</address>
    </div>
  );
}
